import React from 'react';
import type { PropsWithChildren } from 'react';
import {
  FeedActivityItemUserInfoFragmentDoc,
  type FragmentType,
  getFragment,
  gql,
} from '@graphql/reactQuery';
import { FeedActivityHeader } from './FeedActivityHeader';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedActivityItemUserInfo on User {
    id
    hasFeedAccess
    ...UserActivityDetail
  }
`);

export function FeedActivityItem({
  children,
  userFrag,
  description,
  timestamp,
  dropdownContent,
}: PropsWithChildren<{
  userFrag: FragmentType<FeedActivityItemUserInfoFragmentDoc>;
  timestamp: number;
  description: string;
  dropdownContent: React.ReactNode;
}>) {
  const user = getFragment(FeedActivityItemUserInfoFragmentDoc, userFrag);
  return (
    <div className="flex flex-col" data-feed-clickable-div>
      <FeedActivityHeader
        userFrag={user}
        description={description}
        dropdownContent={dropdownContent}
        timestamp={timestamp}
        showFeedCuratorBadge={user.hasFeedAccess}
        showFollowButton
      />
      {/**
       * Actual content
       * Laptop has 66px left padding because 48 for avatar + 16 for gap + 2 for border
       */}
      <div className="w-full pt-4 lg:pl-[66px]" data-feed-clickable-div>
        {children}
      </div>
    </div>
  );
}
